import { render, staticRenderFns } from "./BaseCalendar.vue?vue&type=template&id=6e0fa3db&"
import script from "./BaseCalendar.vue?vue&type=script&lang=ts&"
export * from "./BaseCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports